import { ApolloClient } from 'apollo-client';
import { ArgoContext } from '@awsscm/argo-core/argo';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

interface ContextualFetch {
    (input: Request |string, init?: RequestInit):Promise<Response>;
    context?:ArgoContext;
}

const fetch: ContextualFetch = (input, init?) => {
    if (fetch.context) {
        return fetch.context.fetchWithAwsAuth(input, init);
    } else {
        return Promise.reject('ArgoAppContext not set');
    }
};

const client = new ApolloClient({
    cache: new InMemoryCache({}),
    link: new HttpLink({
        uri: '/graphV2',
        fetch: fetch,
    }),
    queryDeduplication: false
});

/** Gets an ApolloClient in exchange for an ArgoContext. */
export default function getApolloClient(context: ArgoContext) {
    fetch.context = context;
    return client;
}